import script from "./MediaRecorderView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MediaRecorderView.vue?vue&type=script&setup=true&lang=ts"

import "./MediaRecorderView.vue?vue&type=style&index=0&id=464c1736&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-464c1736"]])

export default __exports__